import type { IndeedSyncStatus } from '@tipstrack/shared';

const LABELS: Record<IndeedSyncStatus, string> = {
  not_synced: 'Not synced',
  pending: 'Pending',
  active: 'Active on Indeed',
  inactive: 'Inactive',
  expired: 'Expired',
  error: 'Sync error',
};

/** Indeed sync-state pill; color comes from a per-status CSS class. */
export function SyncStatusPill({ status }: { status: IndeedSyncStatus }) {
  return <span className={`pill sync-${status}`}>{LABELS[status] ?? status}</span>;
}
